import { Button } from 'rsuite';
import MenuIcon from '../../assets/icons/menu.svg';
import BackIcon from '../../assets/icons/back.svg';
import { useCallback, useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import { Link, useNavigate } from 'react-router-dom';

import MailIcon from '../../assets/icons/mail_logo.svg';
import LogoutIcon from '../../assets/icons/logout.svg';
import AboutusIcon from '../../assets/icons/aboutus.svg';
import PolicyIcon from '../../assets/icons/policy.svg';
import CustomerSupportIcon from '../../assets/icons/customer_support.svg';
import OpinionIcon from '../../assets/icons/opinion.svg';
import InsuranceIcon from '../../assets/icons/insurance.svg';
import manIcon from '../../assets/icons/man3.svg';
import womanIcon from '../../assets/icons/woman.svg';
import LoginIcon from '../../assets/icons/baseline_login_24.svg';
import { useUser } from '../../contexts/user';
import { useModal } from '../../contexts/modal';
import { useDiagnosis } from '../../contexts/diagnosis';

interface HeaderProps {
  title: string;
  lastPage: boolean;
  backTo?: string;
  showModal?: boolean;
}

export const Header = (props: HeaderProps) => {
  const { user } = useUser();
  const { showModal, setShowModal } = useDiagnosis();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isLastPage, setIsLastPage] = useState<boolean>(false);
  const { handleOpen } = useModal();

  const handleReservedoctor = useCallback(
    (value: string) => {
      return async (val = value) => {
        console.log(val);
        if (props.backTo) {
          navigate(props.backTo);
        } else {
          navigate(-1);
        }
      };
    },
    [navigate, props.backTo]
  );

  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };
  useEffect(() => {
    setIsLastPage(props.lastPage);
  }, [props.lastPage]);

  useEffect(() => {
    setShowModal(props.showModal ?? false);
  }, [props, props.showModal]);

  return (
    <>
      {/* {!isLastPage ? 'ham' : 'back'} */}
      <ul className="h-14 bg-[--rs-primary-500] text-base flex items-center p-3 text-[--rs-gray-800]">
        {isLastPage ? (
          <Button
            className="custom-icon mr-0"
            onClick={() => {
              if (showModal) {
                handleOpen(
                  handleReservedoctor,
                  'a',
                  `در صورتی که به تشخیص نهایی نرسیده اید و بخواهید از روند معاینه خارج شوید، معاینه کنونی شما ذخیره نخواهد شد و باید از ابتدا به سوال پاسخ دهید. آیا می خواهید از روند معاینه خارج شوید؟`,
                  'توجه',
                  'تا رسیدن به تشخیص به معاینه ادامه بده',
                  'خروج از روند معاینه',
                  true
                );
              } else {
                if (props.backTo) {
                  navigate(props.backTo);
                } else {
                  navigate(-1);
                }
              }
            }}>
            <img src={BackIcon} alt=">" />
          </Button>
        ) : (
          <Button className="custom-icon mr-0" onClick={toggleDrawer}>
            <img src={MenuIcon} alt="=" />
          </Button>
        )}
        <span className="text-md font-bold flex text-[--rs-white] mr-4 mb-0.5">{props.title}</span>
      </ul>
      <Drawer open={isOpen} onClose={toggleDrawer} direction="right" style={{ width: '70%' }}>
        <div
          className="pt-5 flex items-center pb-2 pr-3"
          style={{
            background:
              'linear-gradient(240deg, rgba(0,255,126,1) 0%, rgba(255,195,228,1) 49%, rgba(3,190,237,1) 100%)'
          }}>
          <img src={user.gender === 2 ? womanIcon : manIcon} alt="" />
          <div className="flex flex-col mr-4 text-[--rs-gray-700]">
            <div className="text-[12px]">
              {!user.isLoggedIn ? 'کاربر وارد حساب نشده است!' : null}
            </div>
            {!user.isLoggedIn ? (
              <div
                className="text-[12px] text-[--rs-gray-800] flex mt-3 items-center cursor-pointer"
                onClick={() => {
                  toggleDrawer();
                  navigate('/auth/sign-in');
                }}>
                <img
                  src={LoginIcon}
                  style={{ transform: 'rotate(180deg)', width: ' 20px', marginLeft: 4 }}
                  alt=""
                />
                <span>ورود / ثبت نام</span>
              </div>
            ) : null}
            <div className="text-md">
              {user.name} {user.family}
            </div>
            <div>{user.national_code}</div>
          </div>
        </div>
        <ul>
          <li>
            {' '}
            <Link
              className="flex items-center p-3 text-[--rs-gray-800] hover:bg-[--rs-gray-100]"
              to={user.isLoggedIn ? `/profile` : '/auth/sign-in'}
              onClick={() => {
                toggleDrawer();
              }}>
              <img src={InsuranceIcon} className="h-[24px] ml-4" alt="" />
              احراز هویت / ویرایش پروفایل
            </Link>
          </li>
          <li>
            {' '}
            <Link
              className="flex items-center p-3 text-[--rs-gray-800] hover:bg-[--rs-gray-100]"
              to="/notifications"
              onClick={() => {
                toggleDrawer();
              }}>
              <img src={MailIcon} className="h-[24px] ml-4" alt="" />
              پیام ها
            </Link>
          </li>
          <li>
            {' '}
            <Link
              className="flex items-center p-3 text-[--rs-gray-800] hover:bg-[--rs-gray-100]"
              to="/feedback"
              onClick={() => {
                toggleDrawer();
              }}>
              <img src={OpinionIcon} className="h-[24px] ml-4" alt="" />
              ثبت نظر درمورد برنامه
            </Link>
          </li>
          <li>
            {' '}
            <Link
              className="flex items-center p-3 text-[--rs-gray-800] hover:bg-[--rs-gray-100]"
              to="/support"
              onClick={() => {
                toggleDrawer();
              }}>
              <img src={CustomerSupportIcon} className="h-[24px] ml-4" alt="" />
              پشتیبانی
            </Link>
          </li>
          <li>
            {' '}
            <Link
              className="flex items-center p-3 text-[--rs-gray-800] hover:bg-[--rs-gray-100]"
              to="/tnc"
              onClick={() => {
                toggleDrawer();
              }}>
              <img src={PolicyIcon} className="h-[24px] ml-4" alt="" />
              قوانین و مقررات
            </Link>
          </li>
          <li>
            {' '}
            <Link
              className="flex items-center p-3 text-[--rs-gray-800] hover:bg-[--rs-gray-100]"
              to="/about-us"
              onClick={() => {
                toggleDrawer();
              }}>
              <img src={AboutusIcon} className="h-[24px] ml-4" alt="" />
              درباره ما
            </Link>
          </li>
          {user.isLoggedIn ? (
            <li>
              {' '}
              <Link
                className="flex items-center p-3 text-[--rs-gray-800] hover:bg-[--rs-gray-100]"
                to="/logout"
                onClick={() => {
                  toggleDrawer();
                }}>
                <img src={LogoutIcon} className="h-[24px] ml-4" alt="" />
                خروج از حساب کاربری
              </Link>
            </li>
          ) : null}
        </ul>
      </Drawer>
    </>
  );
};
